import React, { useState } from 'react';
import Modal from '../Modal';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import PageBreak from '../layout/PageBreak';
import Col from '../layout/Col';
import styled from 'styled-components';
import Icon from '../forms/Icon';
import Row from '../layout/Row';
import Button from '../forms/Button';
import { Collapsable } from '../ToggleClick';
import Form from '../forms/Form';
import Preput from '../forms/Preput';
import { generateId, shortHandDateTime } from '../utility/functions';
import ModalFactory from '../Modal';
import GetState from '../GetState';
import Loading from '../Loading';

const ButtonIcon = styled(Icon)`
    cursor: pointer;
    opacity: 0.5;
    transition: all 0.3s;
    &:hover {
        opacity: 1;
    }
`
const IconRow = styled(Row)`
    justify-content: space-around;
`

const UserNotes = ({ customerId, dataSet, updateDataSet, ...props }) => {

    const [userNotes, refreshNotes] = GetState(QuestRoute.user.notes(customerId));
    const [showHidden, setShowHidden] = useState(false);

    if (!userNotes) return <Loading />;

    const updateSet = (key, value) => {
        if (!dataSet || !updateDataSet) return;

        const newData = [...dataSet]
        newData.find(e => e.customerId === customerId)[key] = value
        updateDataSet(newData)
    }

    const hideNote = (note) => {
        HamQuest.put(QuestRoute.user.editNote(customerId, note.noteId), { ...note, isHidden: !note.isHidden })
            .then((res) => {
                refreshNotes();
                updateSet('note', res)
            })
    }

    const addNewNote = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'New Note',
            body: (
                <Form
                    inputs={{ note: '' }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.user.createNotes(customerId), { noteText: e.note })
                            .then((res) => {
                                ModalFactory.close(id)
                                refreshNotes()
                                updateSet('note', res)
                            }))
                    }
                >
                    <Preput
                        label='New Note'
                        name='note'
                        required
                    />
                </Form>
            )
        })
    }

    const editNote = (note) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Edit Note',
            body: (
                <Form
                    inputs={{ note: note.noteText }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.user.editNote(customerId, note.noteId), { ...note, noteText: e.note })
                            .then((res) => {
                                ModalFactory.close(id)
                                refreshNotes()
                                updateSet('note', res)
                            }))
                    }
                >
                    <Preput
                        label='New Note'
                        name='note'
                        required
                    />
                </Form>
            )
        })
    }

    const Note = ({ note, ...props }) => {
        const [showHistory, setShowHistory] = useState(false)
        return (
            <Col style={{ opacity: note.isHidden ? '0.5' : '1' }} gap='0.5em'>
                <b>{shortHandDateTime(note.validFrom)}</b>
                <span>{note.noteText}</span>

                {note.history.length > 0 && (
                    <Collapsable state={showHistory}>
                        {note.history.map(e => (
                            <Col>
                                <b>{shortHandDateTime(e.validFrom)}</b>
                                <span>{e.noteText}</span>
                            </Col>
                        ))}
                    </Collapsable>
                )}

                <IconRow>
                    {!note.isHidden && <ButtonIcon icon='edit' onClick={() => editNote(note)} />}
                    {note.history.length > 0 && <ButtonIcon icon='history' onClick={() => setShowHistory(!showHistory)} />}
                    <ButtonIcon icon={note.noteId ? 'eye' : 'crossEye'} onClick={() => hideNote(note)} />
                </IconRow>
            </Col>
        )
    }

    return (
        <Col>
            <Row justify='space-between'>
                <Button icon={'plus'} onClick={() => addNewNote()} label='Add New' />
                {userNotes.find(e => e.isHidden) && <Button icon={showHidden ? 'crossEye' : 'eye'} onClick={() => setShowHidden(!showHidden)} label={(showHidden ? 'Hide' : 'Show') + ' Hidden'} />}
            </Row>
            <PageBreak padding={1}>
                {
                    userNotes
                        .filter(e => showHidden ? e : !e.isHidden).length > 0 ?
                        userNotes
                            .filter(e => showHidden ? e : !e.isHidden)
                            .map((e, i) => (
                                <Note
                                    key={`${i}-note`}
                                    note={e}
                                />
                            )) : <div>No Notes.</div>
                }
            </PageBreak>
        </Col>
    );
}

export default UserNotes;
